import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed, THEMES } from "@components/atoms/Themed"
import { ResponsiveImageFragment } from "../../types.graphql"
import { twMerge } from "tailwind-merge"
import { EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { FormattedTitle } from "@components/atoms/FormattedTitle"
import { Gradient } from "@components/motion/Gradient"
import { ParallaxCarousel } from "@components/media/ParallaxCarousel"
import { PropsWithChildren } from "react"

export const HeaderPrimary = ({
  title,
  theme,
  featuredImage,
  featuredText,
  children,
}: PropsWithChildren<{
  title?: string
  theme: string
  featuredImage?: ResponsiveImageFragment
  featuredText?: string
}>) => {
  const themeLight = THEMES[`${theme}-light`] ? `${theme}-light` : theme
  const image = featuredImage

  return (
    <Themed
      theme={theme}
      type="bg"
      className="w-full flex flex-col md:flex-row md:pl-7 gap-7 pl-4 pr-4 py-4 justify-between relative"
    >
      {/* {featuredImage?.srcSet?.split(" ")?.[0] && (
        <Gradient
          img={featuredImage.srcSet.split(" ")[0]}
          className="absolute left-0 top-0 h-full"
          aspect="1/1"
          showImage={false}
          cutEdges={false}
          align="left"
          alpha={0.75}
          scale={2.5}
          speed={0.1}
          bg={{ r: 1, g: 1, b: 1 }}
        />
      )} */}
      <Gradient
        theme={theme}
        className="absolute left-0 top-0 h-full bg-white"
        aspect="1/1"
        showImage={false}
        cutEdges={false}
        align="left"
        scale={1}
        // speed={0.5}
        bg={{ r: 1, g: 1, b: 1 }}
      />
      <div className="flex flex-col justify-between items-start w-full self-stretch relative">
        <div className="flex flex-col gap-6 mt-5 type-title-xxl">
          {env.admin ? (
            <EditableText store={usePostTitleEditor()} as="span" placeholder="Enter title" plainText />
          ) : (
            title
          )}
        </div>
        {children ? (
          <div className="mb-4 w-full">{children}</div>
        ) : (
          <div className="flex gap-3 justify-start items-center mb-4 [&_p]:!type-body-m">
            <InnerBlocks
              allowedBlocks={["core/paragraph"]}
              template={[["core/paragraph", { placeholder: "Enter text here" }]]}
            />
          </div>
        )}
      </div>
      <div className="w-full md:w-1/2 h-pageHeaderPrimaryH shrink-0 flex gap-4 flex-nowrap justify-center items-center overflow-hidden relative">
        {/* <ResponsiveImage {...featuredImage} className="w-auto h-full" />
        <ResponsiveImage {...featuredImage} className="w-auto h-full" />
        <ResponsiveImage {...featuredImage} className="w-auto h-full" /> */}
        {image && (
          <ParallaxCarousel
            className="h-full"
            images={[image, image, image]}
            startIndex={1}
            inactiveWidth={0.15}
            useCurrentOffset={false}
            controls={false}
            align="center"
          />
        )}
        {featuredText && (
          <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
            <FormattedTitle text={featuredText} theme={themeLight} />
          </div>
        )}
      </div>
    </Themed>
  )
}
